// src/utils/strayDropGuard.js — v0.319.0 (2026-11-04)
// ---------------------------------------------------------------------------
// A file dropped where nothing takes it must not leave DropPin.
//
// A browser's own answer to a photo dropped on a page is to open that photo
// in place of the page — on an item that means the item, its unsaved words
// and a client's half-written reply are gone. The photo sheet already
// swallowed a missed drop (v0.258); the item editor, the client's report and
// every other screen did not. Found building the chat drop (Brett,
// 2026-11-04: "build it so i can drag photos into chat").
//
// One listener on the window, AFTER every drop zone: a zone that takes the
// drop has already handled it (and usually stopped it); anything that reaches
// here was dropped on nothing, so the browser is told not to open it. A visible
// file box (<input type="file">) still takes its own drop.

function carriesFiles(e) {
  const types = e && e.dataTransfer && e.dataTransfer.types;
  return !!types && Array.from(types).includes('Files');
}

function isFileInput(t) {
  return !!t && t.tagName === 'INPUT' && String(t.type).toLowerCase() === 'file';
}

export function installStrayDropGuard(win = typeof window !== 'undefined' ? window : null) {
  if (!win || win.__droppinStrayDropGuard) return;
  win.__droppinStrayDropGuard = true;
  const stop = (e) => {
    // A zone that wants the drop has said so already (preventDefault).
    if (e.defaultPrevented || !carriesFiles(e) || isFileInput(e.target)) return;
    e.preventDefault();
    if (e.type === 'dragover' && e.dataTransfer) e.dataTransfer.dropEffect = 'none';
  };
  win.addEventListener('dragover', stop);
  win.addEventListener('drop', stop);
}
